import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Track } from '@app/core/models/Track';
import { AuthState } from '@app/core/states/auth.state';
import { RadioState } from '@app/core/states/radio.state';
import { ArchiveTrackModalComponent } from '@app/library/components/modals/archive-track-modal/archive-track-modal.component';
import { MobAddToPlaylistModalComponent } from '@app/library/components/modals/mob-add-to-playlist-modal/mob-add-to-playlist-modal.component';
import { MobMoveTrackModalComponent } from '@app/library/components/modals/mob-move-track-modal/mob-move-track-modal.component';
import { Playlist } from '@app/library/models/playlist.model';
import { BacsState } from '@app/library/states/bacs.state';
import { EditingTrackState } from '@app/library/states/editing-track.state';
import { PlaylistsState } from '@app/library/states/playlists.state';
import { MOBILE_DIALOG_CONFIG } from '@app/shared/constants';
import { environment } from '@env/environment';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

export enum TRACK_ACTION {
  EDIT = 'EDIT',
  DELETE = 'DELETE',
}

@Component({
  selector: 'rk-track-context-menu',
  templateUrl: './track-context-menu.component.html',
  styleUrls: ['./track-context-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrackContextMenuComponent {
  @Select(EditingTrackState.track)
  track$: Observable<Track>;

  @Select(PlaylistsState.playlists)
  playlists$: Observable<Playlist[]>;

  constructor(
    private readonly dialogRef: MatDialogRef<TrackContextMenuComponent>,
    private readonly store: Store,
    private readonly dialog: MatDialog,
    private readonly elRef: ElementRef,
  ) {}

  editTrack() {
    this.exitPanel(TRACK_ACTION.EDIT);
  }

  downloadTrack(track: Track) {
    const radioId = this.store.selectSnapshot(RadioState.currentRadioId);
    const token = this.store.selectSnapshot(AuthState.getAccessToken);
    window.open(
      `${environment.urls.MAIN_API_V2}/radio/${radioId}/track/${track.id}/download?token=${token}`,
    );
    this.exitPanel();
  }

  addToPlaylist(id: number) {
    this.dialog.open(MobAddToPlaylistModalComponent, {
      ...MOBILE_DIALOG_CONFIG,
      data: {
        trackId: id,
      },
    });
  }

  moveTrack(track: Track) {
    this.dialog.open(MobMoveTrackModalComponent, {
      ...MOBILE_DIALOG_CONFIG,
      data: {
        trackId: track.id,
        boxId: track.idTrackbox,
      },
    });
  }

  deleteTrack(track: Track) {
    this.elRef.nativeElement.closest('.mobile-dialog').classList.add('behind-modal');
    const currentBac = this.store.selectSnapshot(BacsState.bacById)(track.id);
    const deleteRef = this.dialog.open(ArchiveTrackModalComponent, {
      ...MOBILE_DIALOG_CONFIG,
      data: {
        track,
        isSingle: true,
        bac: currentBac,
        shortcut: false,
        mobile: true,
      },
    });
    deleteRef.afterClosed().subscribe(() => {
      this.elRef.nativeElement.closest('.mobile-dialog').classList.remove('behind-modal');
    });
  }

  exitPanel(action: TRACK_ACTION = null) {
    this.dialogRef.close({ action });
  }
}
